<template>
  <ModalBackdrop ref="modal-backdrop">
    <div class="share-modal">
      <!-- モーダルヘッダー -->
      <div class="share__header">
        <h3 class="share__header--title">共有</h3>
      </div>

      <!-- モーダルボディ -->
      <div class="share__body">
        <div class="share__btns">
          <!-- LINE共有ボタン -->
          <a :href="shareLine" target="_blank" class="share__body--btn">
            <Icon name="line" />
          </a>

          <!-- メール共有ボタン -->
          <button
            class="share__body--btn"
            @click="emitMail"
          >
            <Icon name="gmail" />
          </button>

          <!-- 内容をコピーボタン -->
          <button
            class="share__body--btn share__body--copy"
            @click.prevent="copyToClipboard"
          >
            <span>内容をコピー</span>
          </button>
        </div>
      </div>
    </div>
  </ModalBackdrop>
</template>

<script>
import ModalBackdrop from "../ModalBackdrop"
export default {
  props: {
    /** 「内容をコピー」ボタン押下時にクリップボードにコピーされる文字列 */
    copyText: String
  },

  computed: {
    /** @returns { string } */
    shareLine() {
      if (this.url) {
        return `https://social-plugins.line.me/lineit/share?url=${this.url}`;
      }
      const url = encodeURIComponent(location.href);
      return `https://social-plugins.line.me/lineit/share?url=${url}`;
    }
  },
  components:{
    ModalBackdrop,
  },
  methods: {
    showModal() {
      this.$refs['modal-backdrop'].showModal();
    },

    /** copyTextをクリップボードにコピーする */
    copyToClipboard() {
      const copyText = this.copyText;
      this.$copy.CopyToClipboard(copyText);
      this.$refs['modal-backdrop'].close()
    },

    /** モーダル非表示後、メールアイコンクリックイベントを送信する */
    emitMail() {
      this.$refs['modal-backdrop'].close();
      this.$emit('click-mail');
    }
  }
};
</script>

<style scoped lang="scss">
.share-modal {
  background-color: white;
  border-radius: 6px;
  width: 60vw;
  height: 25vh;

  @include mq() {
    width: 95vw;
    height: 20vh;
  }
}

.share__header {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30%;
  border-bottom: 1px solid #e60021;

  @include mq() {
    border-bottom: 1px solid #CACCCF;
  }
}

.share__header--title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 0;

  @include mq() {
    font-size: 1.125rem;
  }
}

.share__body {
  height: 70%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.share__btns {
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: repeat(3, auto);
  gap: 28px;

  @include mq() {
    grid-template-rows: repeat(2, auto);
    grid-template-columns: repeat(2, auto);
    gap: 10px 0;
    place-items: center;
  }
}

.share__body--btn {
  background-color: white;
  > svg {
    width: 3rem;
    height: 3rem;

    @include mq() {
      width: 1.5rem;
      height: 1.5rem;
    }
  }
}

.share__body--copy {
  width: 10rem;
  height: 3rem;
  border: 1px solid #73767a;
  border-radius: 6px;
  font-size: 15px;

  @include mq() {
    width: 6rem;
    height: 1.5rem;
    font-size: 13px;
    grid-column: 1/3;
  }
}
</style>
